import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const categoriesApi = async () => {
  try {
    const apiLink = `${endpoint}/api/category`;
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataArray = [];
    if (data) {
      data.forEach((elem) => {
        const obj = {
          id: elem.id,
          name: elem.name || "",
          description: elem.description || "",
        };
        dataArray.push(obj);
      });
    }

    return dataArray;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default categoriesApi;
